import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";
import VueCryptojs from "@/plugins/cryptojs";
import VueLazyload from "@/plugins/lazyload";
import VueSweetalert2 from "@/plugins/sweetalert";
import aos from "@/plugins/aos";
import apiPlugin from "@/plugins/api";
import global from "@/plugins/global";
import GoogleAuth from '@/config/google'
import "./registerServiceWorker";
import filters from "./filters/filters";
import firebaseMessaging from '@/plugins/firebaseInit';
Vue.prototype.$messaging = firebaseMessaging
Vue.use(global);
Vue.use(apiPlugin);
Vue.filter(filters);
Vue.config.productionTip = false;



const gauthOption = {
  // clientId: '304236742777-nd25os19tb6v5kb7i6vd2l59tvsvsbpt.apps.googleusercontent.com',
  clientId: '507970016210-2dhh646ie8kepqmhios24n8hh0084t8l.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account',
  // plugin_name: 'googleAuthVue',
  plugin_name: 'The Concept SA',
}
Vue.use(GoogleAuth, gauthOption)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  VueCryptojs,
  VueLazyload,
  VueSweetalert2,
  aos,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
